/**
 * Service: posConfig
 */
angular.module('acme.common.service.posConfig', [
  'acme.common.service.helpers',
  'acme.common.service.posConfigOptions',
  'acme.common.service.posConfigImages',
  'acme.common.service.posConfigTiles',
  'acme.common.service.posConfigPages',
  'acme.common.service.posConfigNavigation',
  'acme.common.service.posConfigSettings'
])
.service('PosConfigService', [ '$filter', 'PosConfigOptionsService', 'PosConfigImagesService', 'PosConfigPagesService', 'PosConfigTilesService', 'PosConfigNavigationService', 'PosConfigSettingsService', 'HelpersService', function($filter, PosConfigOptionsService, PosConfigImagesService, PosConfigPagesService, PosConfigTilesService, PosConfigNavigationService, PosConfigSettingsService, HelpersService) {

    return {

      options: PosConfigOptionsService,
      images: PosConfigImagesService,
      tiles: PosConfigTilesService,
      pages: PosConfigPagesService,
      navigation: PosConfigNavigationService,
      settings: PosConfigSettingsService,

      init: function() {
        return true;
      },

      /**
       * Updates tile for specific page assumes tiles are already populated in PosConfigTilesService
       *
       * @param pageId {String}
       * @param tile {Tile}
       *
       * @returns {*} {Tile}
       */
      updateTile: function(pageId, tile) {

        var page = PosConfigPagesService.findPage(pageId).page;

        if (PosConfigTilesService.findTile(tile.config.id)) {
          PosConfigTilesService.setTile(tile);
        }else{
          PosConfigTilesService.addTile(tile);
        }

        page.items = PosConfigTilesService.getModel();

        PosConfigPagesService.updatePage(page);

        return PosConfigTilesService.findTile(tile.config.id).tile;

      },

      updateNavigationTiles: function(pageId) {
        var i, ii,
            j, jj,
            page,
            found = PosConfigPagesService.findPage(pageId),
            pages = PosConfigPagesService.getModel();

        if (found) {
          // Update the tiles with new page name
          page = found.page;

          for (i=0,ii=pages.length;i<ii;i++) {
            for (j=0,jj=pages[i].items.length;j<jj;j++) {
              if (pages[i].items[j].config.type === 'navigation' &&
                  pages[i].items[j].config.pageId === page.pageId) {
                pages[i].items[j].name = page.pageHeader;
                pages[i].items[j].pageNumber = page.pageNumber;
              }
            }
            PosConfigPagesService.updatePage(pages[i]);
          }
        }
      },
      
      relinkNavigationTilesAfterPageDeletion: function () {
        var i, ii,
            j, jj,
            k, kk,
            pages = PosConfigPagesService.getModel();

          for (i=0,ii=pages.length;i<ii;i++) {
            for (j=0,jj=pages[i].items.length;j<jj;j++) {
              for (k=0,kk=pages.length;k<kk;k++) {
                if(pages[k].pageId === pages[i].items[j].config.pageId) {
                  pages[i].items[j].pageNumber = pages[k].pageNumber;
                  PosConfigPagesService.updatePage(pages[i]);
                }
              }
            }
          }
      },
      
      getReferencedNavigationTiles: function(pageId) {
        var i, ii,
            j, jj,
            r = [],
            pages = PosConfigPagesService.getModel();

        for (i=0,ii=pages.length;i<ii;i++) {
          for (j=0,jj=pages[i].items.length;j<jj;j++) {
            if (pages[i].items[j].config.type === 'navigation' &&
                pages[i].items[j].config.pageId === pageId) {
              r.push({
                page: pages[i],
                tile: pages[i].items[j]
              });
            }
          }
        }

        return r;

      },

      getRemovedPageTiles: function() {
        var i, ii,
            j, jj,
            r = [],
            ids = [],
            pages = PosConfigPagesService.getModel();

        for (i=0,ii=pages.length;i<ii;i++) {
          ids.push(pages[i].pageId);
        }

        for (i=0,ii=pages.length;i<ii;i++) {
          for (j=0,jj=pages[i].items.length;j<jj;j++) {
            if (pages[i].items[j].config.type === 'navigation' &&
                ids.indexOf(pages[i].items[j].config.pageId) === -1) {
              // Page no longer exists remove the tile
              r.push({
                page: pages[i],
                tile: pages[i].items[j]
              });
            }
          }
        }

        return r;
      },

      updateRemovedPageTiles: function(remove) {
        var i, ii;

        for (i=0,ii=remove.length;i<ii;i++) {
          PosConfigPagesService.removePageTile(remove[i].page.pageId, remove[i].tile);
          PosConfigPagesService.updatePage(remove[i].page);
        }
      },

      getConfig: function(process) {
        var displayItems = PosConfigPagesService.getModel();

        if (process) {
          displayItems = this.process(PosConfigPagesService.getModel());
        }

        return $.extend(PosConfigOptionsService.getModel(), {
          splash: PosConfigImagesService.getModel(),
          settings: PosConfigSettingsService.getModel(),
          displayItems: displayItems,
          headerButtonConfig: PosConfigNavigationService.getModel()
        });
      },

      setConfig: function(config) {
        if (config) {
          PosConfigOptionsService.setModel(config);
          if (config.splash) {
            if(config.splash.images === null && config.splash.displayTime === null) {
              config.splash.images = [];
              config.splash.displayTime = 5;
            }
            PosConfigImagesService.setModel(config.splash);
          }

          if (config.headerButtonConfig instanceof Array && config.headerButtonConfig.length) {
            PosConfigNavigationService.setModel(config.headerButtonConfig);
          }

          if (config.settings) {
            if (config.settings.hasOwnProperty('enableCustomerInputOnPurchase')) {
              PosConfigSettingsService.setModel(config.settings);
            }
          }

          if (config.displayItems instanceof Array && config.displayItems.length) {
            PosConfigPagesService.setModel(config.displayItems);
          } else {
            PosConfigPagesService.setModel( [PosConfigPagesService.create()] );
          }
        }
      },

      process: function(displayItems) {
        var i, ii,
            j, jj,
            items;

        console.log(displayItems);

        for (i=0,ii=displayItems.length;i<ii;i++) {
          items = [];
          for (j=0,jj=displayItems[i].items.length;j<jj;j++) {
            if (displayItems[i].items[j].config.type !== 'tile') {
              items.push(displayItems[i].items[j]);
            }
          }
          displayItems[i].items = items;
        }

        return displayItems;
      },

      /**
       * Parses yyyy-MM-dd and returns Date Object
       *
       * @param date {String}
       * @returns {Date}
       */
      parsePresellDate: function(date) {
        var s = date.split('-'),
            d = new Date(s[0], parseInt(s[1], 10) - 1, s[2], 12, 0, 0, 0);

        return d;
      },

      /**
       * Returns Date Object as yyyy-MM-dd
       *
       * @param date {Date}
       * @returns {String}
       */
      dateToPresellDate: function(date) {
        var r = new Date();

        if (date instanceof Date) {
          r = $filter('date')(date, HelpersService.dateFormats.fieldDate);
        }

        return r;
      },

      /**
       * Returns yyyy-MM-dd as M/d/yy
       * If date is empty returns current date as M/d/yy
       *
       * @param date {String}
       * @returns {String}
       */
      presellDateToTileDate: function(date) {
        var r = new Date();

        if (date) {
          r = $filter('date')(this.parsePresellDate(date), HelpersService.dateFormats.shortDate);
        }else{
          r = $filter('date')(r, HelpersService.dateFormats.shortDate);
        }

        return r;
      },

      reset: function () {
        PosConfigOptionsService.setModel(false);
        PosConfigImagesService.setModel(false);
        PosConfigTilesService.setModel(false);
        PosConfigPagesService.setModel(false);
        PosConfigNavigationService.setModel(false);
        PosConfigSettingsService.setModel(false);
      },

      /**
       * Returns items enabled for pos only
       * @param list {Array}
       * @returns Array
       */
      processPricesBySalesChannel: function(list) {
        var r = [], i, ii, j, jj, channel = 'pointOfSale';

        if (list instanceof Array) {
          for (i=0, ii=list.length; i < ii; i++) {
            if (list[i].salesChannels instanceof Array) {

              for (j=0, jj=list[i].salesChannels.length; j < jj; j++) {
                if ( (list[i].salesChannels[j].channel && list[i].salesChannels[j].channel === channel) && (list[i].salesChannels[j].enabled) ) {
                    r.push(list[i]);
                }
              }

            }
          }
        }

        return r;
      }

    };

}]);